const MEASUREMENT_FIELDS = [
  'binocular_dist_pd',
  'binocular_int_pd',
  'binocular_reading_pd',
  'right_monocular_dist_pd',
  'right_monocular_int_pd',
  'right_monocular_reading_pd',
  'left_monocular_dist_pd',
  'left_monocular_int_pd',
  'left_monocular_reading_pd',
  'right_height_aspheric',
  'right_height_multifocal',
  'right_height_bifocal',
  'right_height_desk',
  'left_height_aspheric',
  'left_height_multifocal',
  'left_height_bifocal',
  'left_height_desk',
];

// DP-5122 / DP-5130: frame shape and frame size are part of the key - PDs with the same numbers for a
// different shape (Capote vs Original) or size (M vs L) are separate records, never one row.
// Null shape = the column default 'classic'. This reverses the DP-5111 call to leave frame size out,
// so DP-4850 duplicates that differ only in frame size are listed separately again.
const measurementKey = pd =>
  [
    pd.glass_shape_type || 'classic',
    (pd.frame_size || '').toUpperCase(),
    ...MEASUREMENT_FIELDS.map(field =>
      pd[field] === null || pd[field] === undefined || pd[field] === '' ? '' : Number(pd[field]),
    ),
  ].join('|');

// Collapses PDs with identical measurements, frame shape and frame size into one row: the newest, or
// the one with keepId when a PD is already selected (DP-4850).
export default function uniquePds(pds, keepId = null) {
  const winners = {};
  [...pds]
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .forEach(pd => {
      const key = measurementKey(pd);
      if (pd.id === keepId || winners[key] === undefined) {
        winners[key] = pd.id;
      }
    });

  return pds.filter(pd => winners[measurementKey(pd)] === pd.id);
}
